import { ListItem, ListItemAvatar, ListItemText, Badge, Avatar, Icon } from '@material-ui/core';
import moment from 'moment';
import React, { useState } from 'react';
import { dateMomentFormat } from 'v2/formatters/date';
import notificationService from 'v2/services/notifications';

import type { INotification } from 'v2/interfaces/notification';

import useStyle from './styles';

const ListItemNotification = ({ notification }: { notification: INotification }) => {
  const currentNotification = notificationService.formatNotification(notification);
  const classes = useStyle();

  const [readed, setReaded] = useState<boolean>(currentNotification.readed);

  const formatedCreateAt = dateMomentFormat(moment(currentNotification.createdAt), 'DD/MM/YYYY - HH:mm');

  return (
    <a target='_blank' rel='noopener noreferrer' href={currentNotification.redirect} onClick={() => setReaded(true)}>
      <ListItem className={classes.listItem}>
        <ListItemAvatar>
          <Badge color='error' invisible={readed} variant='dot' overlap='circular'>
            <Avatar style={{ background: currentNotification.color, color: '#192542' }}>
              <Icon>{currentNotification.icon}</Icon>
            </Avatar>
          </Badge>
        </ListItemAvatar>
        <ListItemText primary={currentNotification.title} secondary={currentNotification.message} />
        <ListItemText className={classes.secondListItemText} secondary={formatedCreateAt} />
      </ListItem>
    </a>
  );
};
export default ListItemNotification;
